<template>
  <div class="carriers-edit"></div>
</template>

<script>
export default {
  name: 'CarriersDetail',
}
</script>
